<template>
  <div>
    <h1>{{ stepState.name }}</h1>

    <div v-html="$sanitize(message)" />

    <div v-if="submitError" class="text-center alert alert-danger">
      {{ $t('enrollmentStep.profile.refreshPage') }}
    </div>

    <form @submit.prevent="saveLotteryNumber">
      <template v-if="!showConfirmation">
        <div class="form-group" :class="{'has-error': errors.has('lottery_number')}">
          <label class="col-form-label">{{ $t('enrollmentStep.lotterySelection.instructions', {digit: stepState.digits}) }}</label>
          <div class="row">
            <div class="col-md-2 col-sm-3">
              <input
                v-model="lottery_number"
                v-validate="validators"
                name="lottery_number"
                type="tel"
                class="form-control form-control-lg"
                :placeholder="placeholder"
                :maxlength="stepState.digits"
              >
            </div>
          </div>
          <ul v-if="errors.has('lottery_number')" class="error-list">
            <li>{{ errors.first('lottery_number') }}</li>
          </ul>
        </div>

        <div v-if="isLotto" class="alert alert-info">
          {{ $t('enrollmentStep.lotterySelection.uniqueDigits') }}
        </div>
      </template>

      <div class="form-group">
        <input value="Continue" :class="{'btn-loading': isSubmitting}" type="submit" class="btn btn-primary">
      </div>
    </form>
  </div>
</template>

<script>
  import BaseStep from './BaseStep.vue';

  export default {
    extends: BaseStep,
    data() {
      return {
        showConfirmation: false,
        isSubmitting: false,
        submitError: false,
        lottery_number: '',
      };
    },
    computed: {
      message() {
        return this.showConfirmation ? this.stepState.confirmation : this.stepState.instructions;
      },
      hasConfirmation() {
        return this.stepState.confirmation != undefined;
      },
      placeholder() {
        return '#'.repeat(this.stepState.digits);
      },
      validators() {
        let rules = `required|length:${this.stepState.digits}|numeric`;
        if (this.isLotto) {
          rules += '|non_repeating'
        }
        return rules;
      },
      isLotto() {
        return this.stepState.ruleset === 'lotto';
      }
    },
    created() {
      this.$validator.extend('non_repeating', {
        getMessage: (field, params) => this.$t('enrollmentStep.lotterySelection.noRepeatDigits'),
        validate: (value) => {
          let repeating = this.lottery_number.split('').some((num, i, arr) => {
            return arr.lastIndexOf(num) != i;
          });

          // return false if any numbers are repeating
          return !repeating;
        }
      });
    },
    methods: {
      saveLotteryNumber() {
        // if we're showing the confirmation, emit a refresh
        if (this.showConfirmation) {
          this.$emit('refresh');
          return;
        }

        // otherwise save the form
        this.$validator.validateAll().then((result) => {
          if (!result) {
            return;
          }
          this.submitError = false;
          this.isSubmitting = true;

          return this.$api.Participants.updateParticipant({
            participant_id: this.participantId,
            patch: [
              { op: "replace", path: `/lottery_number`, value: this.lottery_number }
            ]
          }).then(({status, body}) => {
            if (status >= 400) {
              throw {status: status, body: body};
            }

            this.isSubmitting = false;

            if (this.hasConfirmation) {
              this.showConfirmation = true;
            } else {
              this.$emit('refresh');
            }
          }).catch((error) => {
            const body = error.response.body;
            if (body.field_errors && body.field_errors.length > 0) {
              // the api returned field errors which means the ppt profile failed validation, create an incident
              let msg = ["Participant could not complete lottery verification because of an error in their profile:"];
              body.field_errors.forEach((err) => {
                msg.push("Field: " + err.field);
                msg.push("Message: " + err.message);
              });
              this.$api.Participants.createIncidentForParticipant({
                participant_id: this.participantId,
                body: {
                  "type": "Software",
                  "message": msg.join("\n")
                }
              });
            }

            this.submitError = true;
            this.isSubmitting = false;
          });
        });
      }
    }
  }
</script>
<style scoped>
  [name="lottery_number"] {
    letter-spacing: .5em;
  }
</style>
